import React from 'react';
import PropTypes from 'prop-types';
import Badge from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Badge';

const GeneralCountBadge = ({ children, count }) => {
  return count > 0
    ? (
      <Badge badgeContent={count}>
        {children}
      </Badge>
    )
    : children;
};

GeneralCountBadge.defaultProps = {
  count: 0,
};
GeneralCountBadge.propTypes = {
  count: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default GeneralCountBadge;
